import { getAuthClient } from "@trumpf/ux.utils";
import { AssetManagementApiClient } from "../assetManagementApi/assetManagementApiClient";
import { ProductTechnologyType } from "../productTechnology";
import { authClientName } from "../config";
import { decodeJwt } from "../../utils/jwt/decode-jwt";

export interface ProductType {
    assetId: string;
    technologyId: ProductTechnologyType;
    assetName: string;
}

export const getMachineList = async (apiClient: AssetManagementApiClient): Promise<ProductType[]> => {
    const idToken = getAuthClient(authClientName).getIdToken();
    const decoded = decodeJwt(idToken as string);
    const { customerNumber } = decoded as { customerNumber: string };
    return apiClient
        .request<ParametersResponse>(
            `/asset-management/1.0/core/assets/parameters?customerOrgId=${customerNumber}&isCustomOnly=false&isRootAsset=true`,
            {
                method: "GET",
                mockResponse
            }
        )
        .then((response) => {
            if (response.assets) {
                return response.assets;
            }
            return Promise.reject("No assets found");
        });
};

interface ParametersResponse {
    assets: ProductType[];
}

export const mockResponse: ParametersResponse = {
    assets: [
        {
            assetId: "A0660A0576",
            assetName: "Quicksharp",
            technologyId: "PUNCHING"
        },
        {
            assetId: "LS00093708",
            assetName: "HL 54P",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0551A0120",
            assetName: "HL 101P",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "LS00009160",
            assetName: "HL 2006D",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "LS00093844",
            assetName: "HL 2006D",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "N0053A0020",
            assetName: "SortMaster (AL28)",
            technologyId: "AUTOMATION"
        },
        {
            assetId: "C0200I0005",
            assetName: "Toolshuttle",
            technologyId: "AUTOMATION"
        },
        {
            assetId: "883850",
            assetName: "TRBV85SX",
            technologyId: "BENDING"
        },
        {
            assetId: "B0501A0185",
            assetName: "TruBend 5050",
            technologyId: "BENDING"
        },
        {
            assetId: "B1503I0001",
            assetName: "TruBend 5085 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1504I0151",
            assetName: "TruBend 5130 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1505I0280",
            assetName: "TruBend 5170 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1505I0637",
            assetName: "TruBend 5170 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1507I0001",
            assetName: "TruBend 5230 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1509I0001",
            assetName: "TruBend 5320 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B0702A2028",
            assetName: "TruBend 7036",
            technologyId: "BENDING"
        },
        {
            assetId: "B0702A2031",
            assetName: "TruBend 7036",
            technologyId: "BENDING"
        },
        {
            assetId: "B1703I0086",
            assetName: "TruBend 7050 (B28)",
            technologyId: "BENDING"
        },
        {
            assetId: "E0953A0235",
            assetName: "TruDisk 2001 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E0953A0078",
            assetName: "TruDisk 4002 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1153A0485",
            assetName: "TruDisk 4002 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1153A0426",
            assetName: "TruDisk 6602 (4 C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E0953A0227",
            assetName: "TruDisk 8002 (2C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1053A0162",
            assetName: "TruDisk  3001 (4 C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "A0221E0833",
            assetName: "TruLaser 3030 fiber (L49)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0221E1065",
            assetName: "TruLaser 3030 fiber (L49)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A2221E0146",
            assetName: "TruLaser 3030 fiber (L95)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A3231E0025",
            assetName: "TruLaser 5030 fiber (L76)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A3231E0518",
            assetName: "TruLaser 5030 fiber (L76)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "S2321M0144",
            assetName: "TruLaser Cell 3000 (L34)",
            technologyId: "WELDING"
        },
        {
            assetId: "S0541C0287",
            assetName: "TruLaser Cell 7040 (L31) fiber",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "S0541C0328",
            assetName: "TruLaser Cell 7040 (L31) fiber",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "A0280E0038",
            assetName: "TruLaser Center 7030 (L26)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0280E0127",
            assetName: "TruLaser Center 7030 (L26)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0455A0024",
            assetName: "TruLaser Robot 5020",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A0455A0037",
            assetName: "TruLaser Robot 5020",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A1441D0079",
            assetName: "TruLaser Tube 7000 fiber",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A0150A0160",
            assetName: "TruMatic 7000",
            technologyId: "COMBINED"
        },
        {
            assetId: "A1150D0126",
            assetName: "TruMatic 7000 (K08) Medium format",
            technologyId: "COMBINED"
        },
        {
            assetId: "A0460A0004",
            assetName: "TrumaWeld L 1000",
            technologyId: "WELDING"
        },
        {
            assetId: "A0420A0232",
            assetName: "TRUMPF Lasercell 1005",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "S0711Q0095",
            assetName: "TruPrint 1000 (G01)",
            technologyId: "3DPRINTING"
        },
        {
            assetId: "E0851A0036",
            assetName: "TruPulse 203",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0851A0048",
            assetName: "TruPulse 556",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0652A0387",
            assetName: "VectorMark Compact 1",
            technologyId: "MARKINGLASER"
        }
    ]
};
